/* ==========================================================================
   MOBILE NAV — nowy mechanizm (20.09.2026)

   DLACZEGO OD NOWA, a nie łatka na starym.
   Stare menu mobilne to był `.navbar__links` rozciągany na `position: fixed;
   inset: 0` z animacją `clip-path: circle(...)`. Nie działało — i to
   z trzech niezależnych powodów naraz, co widać było dopiero po zmierzeniu
   elementu, nie po sprawdzeniu, czy jest „widoczny":

   1. `.navbar` ma `backdrop-filter: blur(18px)`, a `.navshell` ma
      `transform`. Każde z nich tworzy CONTAINING BLOCK dla potomków
      `position: fixed`. Przez to `inset: 0` liczyło się względem pigułki
      navbara, nie okna: zmierzony overlay miał 341×144 px w punkcie
      (17, 13), zamiast 375×812 w (0, 0).
   2. Ciemne tło overlaya nie malowało się w ogóle. `.navbar--card
      .navbar__links` (specyficzność 0,2,0) stoi POZA media query i bije
      regułę mobilną `.navbar__links` (0,1,0) — media query nie dodaje
      specyficzności. Skórka „biała karta" z desktopu wyciekła na mobile.
   3. Z tego samego powodu linki brały kolor z `.navshell.is-scrolled
      .navbar--card .navbar__links a` (0,3,1), czyli ciemny grafit —
      stąd ciemny tekst na jasnym tle na zrzucie od Martiny.

   ROZWIĄZANIE: panel montowany bezpośrednio w `<body>`, poza `.navshell`
   i poza `.navbar`. Nie ma nad sobą żadnego przodka z transformem ani
   filtrem, więc `position: fixed` znaczy naprawdę „względem okna", i nie
   łapie ani jednej reguły `.navbar--card` / `.is-scrolled`.

   ŹRÓDŁO TREŚCI: `#navLinks` — ten sam `<ul>`, który obsługuje desktop.
   Panel jest z niego KLONOWANY, więc menu dalej ma jedno źródło prawdy
   w HTML-u i nie trzeba go utrzymywać osobno w `partials/navbar.html`
   i we wklejonej kopii w `index.html`.

   Na Shopify: to samo, tylko klonowane z `snippets/navbar.liquid`.

   POPRAWKA 23.09.2026 (uwaga Martiny): "Umów demo" / "Zapytaj o wycenę"
   (linki z [data-contact]) w podmenu "Dla profesjonalistów" renderowały
   się jak zwykłe linki tekstowe (.mobilenav__sublink) tam gdzie "StethoMe
   Pro" / "Lekarze..." — teraz są wydzielone do własnego rzędu dwóch małych
   przycisków (.mobilenav__cta-row/.mobilenav__cta-btn) na dole podmenu.
   Atrybut data-contact jest zachowany na klonie (cloneNode kopiuje
   atrybuty), więc globalny listener w assets/contact-form.js dalej łapie
   kliknięcie i otwiera formularz — to również naprawia "nic się nie
   dzieje po kliku", bo wcześniej contact-form.js w ogóle nie był wgrany
   do motywu Shopify.
   ========================================================================== */

(function () {
  const source = document.getElementById("navLinks");
  const toggle = document.getElementById("navToggle");
  if (!source || !toggle) return;

  const MOBILE = "(max-width: 1100px)";
  const mq = window.matchMedia(MOBILE);

  /* main.js trzyma własny listener na tym przycisku, który przełącza stare
     menu. Dwa listenery czytające `aria-expanded` i odwracające je nawzajem
     się znoszą, więc podmieniam przycisk na jego klon — klon nie dziedziczy
     listenerów, a wygląd i atrybuty zostają. Referencję trzymamy do klona. */
  const btn = toggle.cloneNode(true);
  toggle.replaceWith(btn);

  const navbar = btn.closest(".navbar");
  let panel = null;
  let lastFocus = null;

  /* ---- Budowa panelu -------------------------------------------------- */
  const build = function () {
    const root = document.createElement("div");
    root.className = "mobilenav";
    root.hidden = true;

    const sheet = document.createElement("div");
    sheet.className = "mobilenav__sheet";
    sheet.setAttribute("role", "dialog");
    sheet.setAttribute("aria-modal", "true");
    sheet.setAttribute("aria-label", "Menu");

    const head = document.createElement("div");
    head.className = "mobilenav__head";
    const close = document.createElement("button");
    close.type = "button";
    close.className = "mobilenav__close";
    close.setAttribute("aria-label", "Zamknij menu");
    close.innerHTML =
      '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    head.appendChild(close);
    sheet.appendChild(head);

    const list = document.createElement("ul");
    list.className = "mobilenav__list";

    [...source.children].forEach((li) => {
      // Przełącznik języka — rząd pigułek na dole, nie pozycja menu.
      if (li.classList.contains("navbar__links-lang")) {
        const row = document.createElement("li");
        row.className = "mobilenav__lang";
        [...li.querySelectorAll("a")].forEach((a) => {
          const c = a.cloneNode(true);
          if (a.getAttribute("aria-current")) c.classList.add("is-active");
          row.appendChild(c);
        });
        list.appendChild(row);
        return;
      }

      // CTA „Kup StethoMe®" — pełnowymiarowy przycisk.
      if (li.classList.contains("navbar__links-cta")) {
        const a = li.querySelector("a");
        if (!a) return;
        const item = document.createElement("li");
        item.className = "mobilenav__ctaitem";
        const c = a.cloneNode(true);
        c.className = "mobilenav__cta";
        item.appendChild(c);
        list.appendChild(item);
        return;
      }

      const trigger = li.querySelector(":scope > a");
      if (!trigger) return;
      const dropdown = li.querySelector(":scope > .navbar__dropdown");
      const item = document.createElement("li");
      item.className = "mobilenav__item";

      // Pozycja bez podmenu (np. „Dla rodziny") — zwykły link, bez strzałki.
      if (!dropdown) {
        const a = trigger.cloneNode(true);
        a.className = "mobilenav__link";
        item.appendChild(a);
        list.appendChild(item);
        return;
      }

      const label = (trigger.textContent || "").trim().split("\n")[0].trim();
      const b = document.createElement("button");
      b.type = "button";
      b.className = "mobilenav__trigger";
      b.setAttribute("aria-expanded", "false");
      b.innerHTML =
        '<span>' + label + '</span><span class="mobilenav__caret" aria-hidden="true"></span>';

      const sub = document.createElement("ul");
      sub.className = "mobilenav__sub";
      sub.hidden = true;

      const ctaLinks = [];
      [...dropdown.querySelectorAll("a")].forEach((a) => {
        if (a.hasAttribute("data-contact")) {
          ctaLinks.push(a);
          return;
        }
        const subItem = document.createElement("li");
        const c = a.cloneNode(true);
        c.className = "mobilenav__sublink";
        subItem.appendChild(c);
        sub.appendChild(subItem);
      });

      // Umów demo / Zapytaj o wycenę — małe przyciski obok siebie, nie linki
      // tekstowe wymieszane z resztą podmenu (uwaga Martiny 23.09.2026).
      if (ctaLinks.length) {
        const row = document.createElement("li");
        row.className = "mobilenav__cta-row";
        ctaLinks.forEach((a) => {
          const c = a.cloneNode(true);
          c.className = "mobilenav__cta-btn";
          row.appendChild(c);
        });
        sub.appendChild(row);
      }

      b.addEventListener("click", () => {
        const open = b.getAttribute("aria-expanded") === "true";
        // Jeden otwarty naraz — panel na telefonie jest krótki.
        list.querySelectorAll(".mobilenav__trigger").forEach((other) => {
          if (other !== b) {
            other.setAttribute("aria-expanded", "false");
            other.parentElement.querySelector(".mobilenav__sub").hidden = true;
          }
        });
        b.setAttribute("aria-expanded", String(!open));
        sub.hidden = open;
      });

      item.appendChild(b);
      item.appendChild(sub);
      list.appendChild(item);
    });

    sheet.appendChild(list);
    root.appendChild(sheet);
    document.body.appendChild(root);

    close.addEventListener("click", () => setOpen(false));

    /* Kliknięcie w tło zamyka. Sprawdzamy `=== root`, bo klik w arkusz
       też bąbelkuje tutaj. */
    root.addEventListener("click", (e) => {
      if (e.target === root) setOpen(false);
    });

    /* Każdy link zamyka menu. Kotwice (#rada-medyczna) na tej samej stronie
       nie przeładowują dokumentu, więc bez tego panel zostałby otwarty
       nad miejscem, do którego użytkownik właśnie skoczył. */
    root.addEventListener("click", (e) => {
      const a = e.target.closest("a");
      if (a && !a.classList.contains("is-active")) setOpen(false);
    });

    return root;
  };

  /* ---- Otwieranie / zamykanie ----------------------------------------- */
  const setOpen = function (open) {
    if (open && !panel) panel = build();
    if (!panel) return;

    if (open) {
      lastFocus = document.activeElement;
      panel.hidden = false;
      // Wymuszenie reflow, żeby przejście zadziałało od stanu zamkniętego.
      void panel.offsetWidth;
      panel.classList.add("is-open");
      document.body.style.overflow = "hidden";
      const first = panel.querySelector(".mobilenav__close");
      if (first) first.focus();
    } else {
      panel.classList.remove("is-open");
      document.body.style.overflow = "";
      // Chowamy dopiero po przejściu, żeby nie zniknęło w pół animacji.
      const done = () => {
        if (!panel.classList.contains("is-open")) panel.hidden = true;
        panel.removeEventListener("transitionend", done);
      };
      panel.addEventListener("transitionend", done);
      setTimeout(done, 400); // gdy transitionend nie przyjdzie (reduced motion)
      if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
    }

    // `nav-open` na navbarze zostaje — to on animuje hamburgera w X.
    if (navbar) navbar.classList.toggle("nav-open", open);
    btn.setAttribute("aria-expanded", String(open));
    btn.setAttribute("aria-label", open ? "Zamknij menu" : "Otwórz menu");
  };

  btn.addEventListener("click", () => {
    setOpen(btn.getAttribute("aria-expanded") !== "true");
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && panel && panel.classList.contains("is-open")) {
      setOpen(false);
      btn.focus();
    }
  });

  /* Przejście na desktop przy otwartym menu zostawiłoby zablokowany scroll
     pod niewidocznym panelem. */
  mq.addEventListener("change", (e) => {
    if (!e.matches) setOpen(false);
  });
})();
